import { PictureData } from "src/app/annotation/canvas/canvas.component";
import { FacadeDetailPhotoRemarksDto } from "src/app/shared/Models/write/facadeDetailPhotoRemarks.model";

export class PhotoViewmodel {
  facadePhotos: PictureInfo[] = [];
  detailPhotos: PictureInfo[] = [];
  facadeComment?: string;
  detailComment: FacadeDetailPhotoRemarksDto[] = [];
}

export class PictureInfo {
  constructor(obj: Partial<PictureInfo>) {
    Object.assign(this, obj);
  }

  data?: PictureData;
  facadeDetailPhotoRemark?: string;
  index?: number;
  remarkChanged?: boolean = false;
}
